export const SpecialistSearchCondition = [{
    name: '专业领域',
    key: '领域分类',
    open: false,
    box: [{
      title: '',
      key: '0',
      list: [{
        title: '',
        key: '0-0',
        items: [{
            index: 0,
            name: '全部',
            key: '领域全部',
            active: false
          },
          {
            index: 1,
            name: '智慧应用',
            key: '智慧应用',
            active: false
          },
          {
            index: 2,
            name: '数据智能',
            key: '数据智能',
            active: false
          },
          {
            index: 3,
            name: '生态系统',
            key: '生态系统',
            active: false
          },
          {
            index: 4,
            name: '可信安全',
            key: '可信安全',
            active: false
          },
          {
            index: 5,
            name: '新型网络',
            key: '新型网络',
            active: false
          },
          {
            index: 6,
            name: '科创平台',
            key: '科创平台',
            active: false
          },
          {
            index: 7,
            name: '数字上云',
            key: '数字上云',
            active: false
          },
          {
            index: 8,
            name: '金融服务',
            key: '金融服务',
            active: false
          },
        ]
      }, ]
    }, ]
  },
  {
    name: '职称',
    key: '职称',
    open: false,
    box: [{
      title: '',
      key: '0',
      list: [{
        title: '',
        key: '0-0',
        items: [{
            index: 0,
            name: '全部',
            key: '职称全部',
            active: false
          },
          {
            index: 1,
            name: '正高',
            key: '正高',
            active: false
          },
          {
            index: 2,
            name: '副高',
            key: '副高',
            active: false
          },
          {
            index: 3,
            name: '中级',
            key: '中级',
            active: false
          },
          {
            index: 4,
            name: '中级以下',
            key: '中级以下',
            active: false
          },

        ]
      }, ]
    }, ]
  },

]
